<div class="company-head">
  <div class="lookupDataList __section">
    @if (activeUrl !== '/cms-preference') {
      <div class="lookupDatalist__management listPage__Description">
        <app-list-page-header
          headerTitle="{{tabvalue === 'workflows'? 'Workflows' : companyDoc?._id ? 'Metadata Fields: '+companyDoc.name : envType === appType.dams? 'Custom Document Category':envType === appType.clms ?'Master Data':''}}"
        headerDescription="{{tabvalue === 'workflows'? 'Manage your documents workflow from this section' : companyDoc?._id ? 'Define Metadata fields for Document Category' : 'Manage your master data'}}"></app-list-page-header>
      </div>
    }
  </div>
  @if (tabvalue == 'documentmetadata') {
    <div style="display: flex;" >
      <app-common-button buttonClass="regularButton" buttonLabel="Back" (clickEvent)="gotoBack()"
      style="margin-right: 10px;"></app-common-button>
      @if (commonService.orgLock() && hasEditAccess) {
        <app-common-button appAccessControl restrictedModules="documentVault.ocrCategory" buttonClass="regularButton" buttonLabel="Add New" (clickEvent)="addLookup()"></app-common-button>
      }
    </div>
  }
  @if (commonService.orgLock() && commonService.hasAllowedAction()) {
    @if (activeUrl !== '/cms-preference' && this.tabvalue!='documentmetadata') {
      <div>
        <app-common-button buttonClass="regularButton" buttonLabel="Add New" appAccessControl allowedRoles="workflow.create"
        (clickEvent)="AddDocumentType()"></app-common-button>
      </div>
    }
  }
  @if (tabvalue == 'module') {
    <div>
      <app-common-button buttonClass="regularButton" buttonLabel="Add New" (clickEvent)="addModule()"></app-common-button>
    </div>
  }
</div>

@if (commonService.orgLock() && commonService.hasAllowedAction()) {
  @if (activeUrl === '/cms-preference') {
    <div>
      <app-common-button buttonClass="regularButton" buttonLabel="Add New"
      (clickEvent)="AddDocumentType()"></app-common-button>
    </div>
  }
}

@if (tabvalue != 'documentmetadata') {
  <ul class="nav nav-tabs" id="myTab">
    <li appAccessControl [allowedModules]="'documentVault.enabled'" allowedRoles="document.view" class="nav-item " [ngClass]="{ active: tabvalue === 'documenttype'}">
      <a data-toggle="tab" (click)="onTabselect('documenttype')">Document Category</a>
    </li>
    <li appAccessControl [allowedModules]="'contractManagementSystem.enabled'" class="nav-item" [ngClass]="{ active: tabvalue === 'recordtype'}">
      <a data-toggle="tab" (click)="onTabselect('recordtype')">Record Type</a>
    </li>
    <li appAccessControl [allowedModules]="'contractManagementSystem.enabled'"  class="nav-item" [ngClass]="{ active: tabvalue === 'contracttype'}">
      <a data-toggle="tab" (click)="onTabselect('contracttype')">Contract Type</a>
    </li>
    <li  appAccessControl [allowedModules]="'workFlow.enabled'" allowedRoles="workflow.view,workflow.delete,workflow.update,workflow.create"  class="nav-item"  [ngClass]="{ active: tabvalue === 'departments'}">
      <a data-toggle="tab" (click)="onTabselect('departments')">Departments</a>
    </li>
    <li appAccessControl [allowedModules]="'workFlow.enabled'" allowedRoles="workflow.view,workflow.delete,workflow.update,workflow.create"  class="nav-item"  [ngClass]="{ active: tabvalue === 'workflows'}">
      <a data-toggle="tab" (click)="onTabselect('workflows')">Workflows</a>
    </li>
  </ul>
}


@if (tabvalue == 'documentmetadata') {
  <div>
    <table class="custom-table-list" aria-label="cred_table">
      <thead>
        <tr class="custom-table-list-headings">
          <th class="custom-col-width-30">Label</th>
          <th class="custom-col-width-20">Required</th>
          <th class="custom-col-width-20">Field Type</th>
          <th class="custom-col-width-20">Status</th>
          <th class="custom-col-width-20">Action</th>
        </tr>
      </thead>
      <tbody>
        @for (value of metadataList; track value) {
          <tr class="custom-table-list-row-main">
            <td class="custom-col-width-30">{{value?.label}}</td>
            <td class="custom-col-width-20">{{value?.validateRequire?'Yes':'No'}}</td>
            <td class="custom-col-width-20">{{value?.fieldType}}</td>
            <td class="custom-col-width-20">{{value?.status}}</td>
            <td class="custom-col-width-20">
              <span class="d-flex justify-content-start">
                @if (hasEditAccess) {
                  <span data-bs-toggle="tooltip" ngbTooltip="Edit" [placement]="'top'">
                    <div tooltipClass="custom-tooltip" (click)="editLookup(value)" class="btn btn-primary btn-sm me-2"
                      style="background-color: #de7141; border-color: #de7141;">
                      <fa-icon [icon]="faEdit"></fa-icon>
                    </div>
                  </span>
                }
                @if (commonService.orgLock()) {
                  @if (value.status ==='Enabled' && hasEditAccess) {
                    <app-common-icon [faIcon]="faBan"
                      ngbTooltip="Disable" [placement]="'top'" class="btn btn-primary btn-sm me-2 custom-disable"
                    (click)="disableMetadata(value,'Enabled')" [loadingIcon]="value.enabledLoader"></app-common-icon>
                  }
                  @if (value.status ==='Disabled' && hasEditAccess) {
                    <app-common-icon [faIcon]="faCircleCheck"
                      ngbTooltip="Enable" [placement]="'top'" class="btn btn-primary btn-sm me-2 custom-disable"
                    (click)="disableMetadata(value,'Disabled')" [loadingIcon]="value.disableLoader"></app-common-icon>
                  }
                }
                <app-common-icon [faIcon]="faHistory" ngbTooltip="History" [placement]="'top'"
                  class="btn btn-primary btn-sm me-2 custom-disable" (click)="getFieldHistory(value, fieldHistory)"
                [loadingIcon]="value.verifyLoader"></app-common-icon>
              </span>
            </td>
          </tr>
        }
        @if (isLoadRecords) {
          <tr class="custom-table-list-row-main">
            <td class="custom-col-width-100 text-danger d-flex justify-content-center">
              <app-common-icon [loadingIcon]="isLoadRecords"></app-common-icon>
            </td>
          </tr>
        }
        @if (!isLoadRecords && metadataList?.length === 0) {
          <tr class="custom-table-list-row-main">
            <td class="custom-col-width-100 text-danger d-flex justify-content-center">
              No Metadata Found!
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}

@if (envType === appType.dams && tabvalue == 'documenttype') {
  <div>
    <app-document-type-list [tabvalue]="tabvalue" [isDocumentType]="isdocumenttype"
    (viewDoc)="viewDocmentType($event)"></app-document-type-list>
  </div>
}
@if (tabvalue == 'recordtype' || tabvalue == 'contracttype' ) {
  <ng-container appAccessControl
    [allowedModules]="'contractManagementSystem.enabled'">
    <div>
      @if (isLoadRecords) {
        <div>
          <div class="custom-col-width-100 text-danger d-flex justify-content-center">
            <app-common-icon [loadingIcon]="isLoadRecords"></app-common-icon>
          </div>
        </div>
      }
      @if (!isLoadRecords && masterData?.length === 0) {
        <div>
          <div class="pt-3 custom-col-width-100 text-danger d-flex justify-content-center">
            No {{tabvalue === 'contracttype' ? 'Contract Type' : 'Record Type'}} Found!
          </div>
        </div>
      }
      <app-clms-contract-types [masterData]="masterData" (updateData)="updateContactTypesData($event)"
      [selectedType]="tabvalue"></app-clms-contract-types>
    </div>
  </ng-container>
}

@if (envType === appType.dams && tabvalue == 'departments') {
  <div>
    <app-departments-list>
    </app-departments-list>
  </div>
}

@if (tabvalue == 'workflows') {
  <div>
    <app-workflow-list>
    </app-workflow-list>
  </div>
}

@if (openWorkflowPanel) {
  <div class="overlay" [class.show]="openWorkflowPanel"></div>
}
@if (openWorkflowPanel) {
  <div class="off-canvas width-1000" [class.show]="openWorkflowPanel">
    <div class="off-canvas-content">
      <app-add-workflow [mode]="'create'" [company]="selfDetails.company" (closePopup)="closeWorkflowPanel($event)"></app-add-workflow>
    </div>
  </div>
}


@if (isLookup) {
  <div class="overlay" [class.show]="isLookup"></div>
}
@if (isLookup) {
  <div class="off-canvas width-450" [class.show]="isLookup">
    <div class="off-canvas-content">
      <app-add-lookup [editItem]="editItem" [companyDoc]="companyDoc"
      (closePanel)="onCloseIconClick($event)" (submitForm)="onSubmit($event)"></app-add-lookup>
    </div>
  </div>
}

<div class="overlay" [class.show]="openDepartmentPanel"></div>
@if (openDepartmentPanel) {
  <div class="off-canvas width-450" [class.show]="openDepartmentPanel">
    <div class="off-canvas-content">
      <app-add-department (closePanel)="closeDepartmentPanel()"
      (successToster)="successTosterFromAddDepartmentComponent($event)"></app-add-department>
    </div>
  </div>
}

@if (isSuccessToster) {
  <div class="toaster_message">
    <app-error-toaster [title]="uploadErrorMessage" (closeToaster)="closingToster($event)"></app-error-toaster>
  </div>
}

@if (isToasterMessage) {
  <div class="toaster_message">
    <app-toast [title]="uploadErrorMessage" (closeToaster)="closingToster($event)"></app-toast>
  </div>
}

<div class="overlay" [class.show]="isOpenAddMasterDataPanel"></div>
@if (isOpenAddMasterDataPanel) {
  <div class="off-canvas width-450" [class.show]="isOpenAddMasterDataPanel">
    <div class="off-canvas-content">
      <app-clms-add-contract-type [selectedType]="tabvalue"
      (closePanel)="closeAddClmsMasterDataType($event)"></app-clms-add-contract-type>
    </div>
  </div>
}



<ng-template tabindex="-1" #fieldHistory  aria-labelledby="fieldHistory" aria-hidden="true"
  let-fieldHistory>
  <div class="modal-header">
    <h5 class="modal-title">Metadata Logs : {{label}}</h5>
    <div class="closeIcon" (click)="fieldHistory.dismiss(false)"><img
    src="../../../../assets/Images/organisation-structure/Cross.svg" alt="cross icon"></div>
  </div>
  <div class="modal-body">
    <table class="table" aria-label="metadataHistory">
      <thead>
        <tr>
          <th class="fieldHistory__Name">Date</th>
          <th class="fieldHistory__Name log">Logs</th>
        </tr>
      </thead>
      <tbody>
        @for (item of fieldHistoryList; track item) {
          <tr>
            <td class="fieldHistory__Name date">{{item?.created | date:"dd MMM yy, hh:mm a"}}</td>
            <td class="fieldHistory__Name">
              @for (msg of item.messages; track msg) {
                <tr>
                  <ul class="history-b">
                    <li>{{msg}}</li>
                  </ul>
                </tr>
              }
            </td>
          </tr>
        }
        @if (fieldHistoryList.length === 0) {
          <tr style="text-align: center;">
            <div class="text-danger"><small>No history found</small></div>
          </tr>
        }
      </tbody>
    </table>
  </div>
</ng-template>